export const ENDPOINTS = {
  register: '/auth/register'
};
